import { supabase } from './supabaseClient';

// "Eliminar mi cuenta" (sql/090). La dueña solicita y tiene 30 días para
// cancelar; alguien del equipo se elimina al momento (api/cuenta-eliminar).
export const DIAS_PARA_ELIMINAR = 30;

export async function solicitarEliminacion(motivo) {
  const { data, error } = await supabase.rpc('solicitar_eliminacion', { p_motivo: motivo || null });
  if (error) throw new Error('No se pudo enviar la solicitud. Intenta de nuevo.');
  return data;
}

export async function cancelarEliminacion() {
  const { error } = await supabase.rpc('cancelar_eliminacion');
  if (error) throw new Error('No se pudo cancelar. Intenta de nuevo.');
}

async function llamar(ruta, cuerpo) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) throw new Error('Tu sesión expiró. Vuelve a entrar.');
  const r = await fetch(ruta, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session.access_token}` },
    body: JSON.stringify(cuerpo || {}),
  });
  const d = await r.json().catch(() => ({}));
  if (!r.ok || d.error) throw new Error(d.mensaje || 'No se pudo completar. Intenta de nuevo.');
  return d;
}

// Equipo: borra su propio usuario al momento.
export const eliminarMiUsuario = () => llamar('/api/cuenta?accion=eliminar');

// Admin: borra definitivamente un negocio con la solicitud vencida.
export const adminEliminarNegocio = (negocioId) => llamar('/api/cuenta?accion=admin-eliminar', { negocioId });

// Fecha en que se elimina (solicitud + 30 días).
export const fechaEliminacion = (solicitada) =>
  new Date(new Date(solicitada).getTime() + DIAS_PARA_ELIMINAR * 86400000);
